export const wait = ms => new Promise(resolve => setTimeout(resolve, ms));
export const all = promises => {
  return Promise.all(promises.map(p => p.catch(() => null)));
};
